import LocalStorageService from "../../services/LocalStorageService";

export const getCompanyIdentityAttributeRus = (value) => {
  const valueUpper = value.toUpperCase();
  switch (valueUpper) {
    case "BIN":
      return "БИН";
    case "INN":
      return "ИНН";
    default:
      return valueUpper;
  }
};

export const getOrganizationIdentityAttribute = () => {
  const tenantId = LocalStorageService.getTenantId();
  switch (tenantId) {
    case "1":
      return "BIN";
    case "7":
      return "INN";
    default:
      return "INN";
  }
};
